import React from 'react'

class AMDErrorBoundary extends React.Component {
  constructor (props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError (error) {
    // Check if this is the AMD define error
    if (error.message && error.message.includes('Can only have one anonymous define call per script file')) {
      // Reload the page immediately
      console.error('detected amd define error, reloading page', error)
      window.location.reload()
      return { hasError: true }
    }

    // For other errors, let them bubble up to parent error boundaries
    throw error
  }

  componentDidCatch (error, errorInfo) {
    // Only handle AMD define errors
    if (error.message && error.message.includes('Can only have one anonymous define call per script file')) {
      console.error('AMD define error detected, reloading page', error)
      window.location.reload()
    } else {
      // Re-throw other errors to let parent boundaries handle them
      throw error
    }
  }

  render () {
    if (this.state.hasError) {
      // This shouldn't be reached since we reload, but just in case
      return <div>Reloading...</div>
    }

    return this.props.children
  }
}

export default AMDErrorBoundary
